import logo from './logo.svg';
import './App.css';
import Restaurent from './Componenent/Basic/Restaurent';

function App() {
  return (
    <div>
      <Restaurent/>
    </div>
  );
}

export default App;
